import Grid from '@mui/material/Grid';
import {
  flowsVinculationFilterAction,
  statusVinculationFilterAction,
  typeVinculationFilterAction,
} from '_models/redux/filter_order_vinculation/action';
import { orderVinculationListAction } from '_models/redux/order_vinculation_list/action';
import { orderVinculationListClean } from '_models/redux/order_vinculation_list/clean-action';
import { orderVinculationDetailListAction } from '_models/redux/order_vinculation_list_details/action';
import { orderVinculationDetailListClean } from '_models/redux/order_vinculation_list_details/clean-action';
import { orderVinculationSessionsDetailAction } from '_models/redux/order_vinculation_sessions_details/action';
import { orderVinculationSessionsDetailClean } from '_models/redux/order_vinculation_sessions_details/clean-action';
import { useState } from 'react';
import { connect } from 'react-redux';
import VinculationSessions from 'widgets/customDialogComponentDetails/componentsDetails/VinculationSessions';
import DialogsVinculation from './components/DialogsVinculation';
import FiltroListVinculation from './components/FiltroListVinculation';
import TableVinculation from './components/TableVinculation';
import { useListVinculation } from './hooks/useListVinculation';

const PageOrderListVinculation = ({
  orderVinculationListAction,
  orderVinculationList,
  orderVinculationListClean,
  orderVinculationDetailListAction,
  orderVinculationDetailList,
  orderVinculationDetailListClean,
  orderVinculationSessionsDetail,
  orderVinculationSessionsDetailAction,
  orderVinculationSessionsDetailClean,
  onClose,
  statusVinculationFilterAction,
  statusVinculationFilter,
  flowsVinculationFilterAction,
  flowsVinculationFilter,
  typeVinculationFilterAction,
  typeVinculationFilter,
}) => {
  const [sessionModalData, setSessionModalData] = useState(null);

  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    getBackgroundColor,
    handleOpenPopUp,
    statusOptions,
    flowsOptions,
    typeOptions,
  } = useListVinculation({
    orderVinculationListAction,
    orderVinculationList,
    orderVinculationListClean,
    orderVinculationDetailListAction,
    orderVinculationDetailList,
    orderVinculationDetailListClean,
    orderVinculationSessionsDetailAction,
    orderVinculationSessionsDetail,
    orderVinculationSessionsDetailClean,
    onClose,
    statusVinculationFilterAction,
    statusVinculationFilter,
    flowsVinculationFilterAction,
    flowsVinculationFilter,
    typeVinculationFilterAction,
    typeVinculationFilter,
  });
  const [hasSearched, setHasSearched] = useState(false);
  const onSubmitWithFlag = async (...args) => {
    const result = await onSubmit(...args);
    if (result !== false) {
      setHasSearched(true);
    } else {
      setHasSearched(false);
    }
  };
  const handleOpenSessionModal = (sessions, transactionId) => {
    setSessionModalData({ sessions, transactionId });
  };

  const handleCloseSessionModal = () => {
    setSessionModalData(null);
  };

  const extraAcceptButton = {
    label: 'Aceptar',
    variant: 'contained',
    onClick: handleClose,
    buttonColor: 'purple',
    textColor: 'white',
  };

  return (
    <>
      <Grid>
        <h4>Órdenes de Vinculación</h4>
      </Grid>
      <Grid marginBottom={4}>
        <FiltroListVinculation
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
          statusOptions={statusOptions}
          flowsOptions={flowsOptions}
          typeOptions={typeOptions}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Grid>
      <TableVinculation
        loading={loading}
        hasSearched={hasSearched}
        mappedRows={mappedRows}
        Columns={Columns}
        page={page}
        size={size}
        pagination={pagination}
        handleRowClick={handleRowClick}
        getBackgroundColor={getBackgroundColor}
      />

      <DialogsVinculation
        isDialogOpenDetails={isDialogOpenDetails}
        handleClose={handleClose}
        orderVinculationDetailList={orderVinculationDetailList}
        handleOpenPopUp={handleOpenPopUp}
        handleOpenSessionModal={handleOpenSessionModal}
        extraAcceptButton={extraAcceptButton}
        isDialogOpen={isDialogOpen}
        dialogMessage={dialogMessage}
      />
      {sessionModalData && (
        <VinculationSessions
          sessions={sessionModalData?.sessions}
          transactionId={sessionModalData?.transactionId}
          setIsSessionModalOpen={(isOpen) => {
            if (!isOpen) handleCloseSessionModal();
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  orderVinculationList: state?.orderVinculationList,
  orderVinculationDetailList: state?.orderVinculationDetailList,
  orderVinculationSessionsDetail: state?.orderVinculationSessionsDetail,
  statusVinculationFilter: state?.statusVinculationFilter,
  flowsVinculationFilter: state?.flowsVinculationFilter,
  typeVinculationFilter: state?.typeVinculationFilter,
});
const mapDispatchToProps = {
  orderVinculationListAction,
  orderVinculationListClean,
  orderVinculationDetailListAction,
  orderVinculationDetailListClean,
  orderVinculationSessionsDetailAction,
  orderVinculationSessionsDetailClean,
  statusVinculationFilterAction,
  flowsVinculationFilterAction,
  typeVinculationFilterAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageOrderListVinculation);
